import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApi } from "@/core/api";
import type { PayrollStatementNotificationState } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import {
  payrollStatementNotificationsKey,
  payrollStatementNotificationsPath,
} from "./keys";

export const useSavePayrollStatementNote = (
  businessId: string | null,
  periodStart: string | null,
) => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: { technicianId: string; note: string }) => {
      if (!businessId || !periodStart) {
        throw new Error("Pay period is required");
      }

      return api
        .put(
          `${payrollStatementNotificationsPath(businessId, periodStart)}/note`,
          { technician_id: input.technicianId, note: input.note },
        )
        .then(
          (res) => res.data as { technician_id: string; note: string | null },
        );
    },
    onSuccess: ({ technician_id, note }) => {
      queryClient.setQueriesData<PayrollStatementNotificationState>(
        { queryKey: payrollStatementNotificationsKey(businessId, periodStart) },
        (state) =>
          state
            ? {
                ...state,
                recipients: state.recipients.map((recipient) =>
                  recipient.technician_id === technician_id
                    ? { ...recipient, note }
                    : recipient,
                ),
              }
            : state,
      );
    },
  });
};
